module.exports = {
    digitalPayMessages: {
        creditCardCvvMessage: 'In order to proceed with your order we need to verify your credit card',
        genericDeleteMessage: 'Are you sure you would like to delete your saved card from your account?',
        creditCardDeleteMessage: 'Are you sure you would like to delete your saved card from your account?',
        giftCardDeleteMessage: 'Are you sure you would like to delete your saved card from your account?',
        paypalUnlinkMessage: 'Are you sure you would like to unlink PayPal from your account?',
        accountPaymentWhenListUnavailableMessage: 'You can continue to make Account payments or try refreshing the page.',
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/digitalpay-messages.js